import React from 'react';
import { Grid, TextField, IconButton, Typography, MenuItem, withStyles } from '@material-ui/core';
import { operators, operatorsForBoolean } from './RuleOperators';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import OutlinedSelect from '../../../controls/OutlinedSelect';

const styles = () => ({
    alignEnd: {
        textAlign: 'end',
    },
});

class ConditionTable extends React.Component {
    handleChange = (newConditions, ruleIndex) => {
        const event = {
            target: {
                name: 'conditions',
                value: newConditions,
            },
        };
        this.props.handleRuleChange(event, ruleIndex);
    };

    handleConditionChange = (event, ruleIndex, subIndex) => {
        const tag = event.target.name;
        const value = event.target.value;
        const newCondition = {
            ...this.props.conditions[subIndex],
            [tag]: value,
        };
        const newConditions = [
            ...this.props.conditions.slice(0, subIndex),
            newCondition,
            ...this.props.conditions.slice(subIndex + 1),
        ];
        this.handleChange(newConditions, ruleIndex);
    };

    addRow(ruleIndex, subIndex) {
        const newRow = {
            fact: '',
            operator: '',
            value: '',
        };
        const newConditions = [
            ...this.props.conditions.slice(0, subIndex + 1),
            newRow,
            ...this.props.conditions.slice(subIndex + 1),
        ];
        this.handleChange(newConditions, ruleIndex);
    }

    deleteRow(ruleIndex, subIndex) {
        if (this.props.conditions.length > 1) {
            const newConditions = [
                ...this.props.conditions.slice(0, subIndex),
                ...this.props.conditions.slice(subIndex + 1),
            ];
            this.handleChange(newConditions, ruleIndex);
        } else {
            const newConditions = [
                {
                    fact: '',
                    operator: '',
                    value: '',
                },
            ];
            this.handleChange(newConditions, ruleIndex);
        }
    }

    render() {
        const { ruleIndex, booleanOperator, conditions } = this.props;
        const valuesForBoolean = [
            {
                label: 'True',
                value: true,
            },
            {
                label: 'False',
                value: false,
            },
        ];
        return (
            <React.Fragment>
                {conditions.map((condition, subIndex) => {
                    const isBooleanEntry = this.props.entries.find((entry) => {
                        return entry.field === condition.fact && entry.typeId === 'boolean';
                    });
                    const operatorsList = isBooleanEntry ? operatorsForBoolean : operators;
                    return (
                        <Grid
                            item
                            container
                            key={`Rule${ruleIndex}-Condition${subIndex}`}
                            alignItems="center"
                            spacing={2}
                        >
                            <Grid item xs={3}>
                                <OutlinedSelect
                                    id={'fact' + ruleIndex + '-' + subIndex}
                                    label="Fact"
                                    name={'fact'}
                                    margin="dense"
                                    value={condition.fact}
                                    onChange={(e) => this.handleConditionChange(e, ruleIndex, subIndex)}
                                >
                                    {this.props.entries.map((entry) => (
                                        <MenuItem key={entry.field} value={entry.field}>
                                            {entry.field}
                                        </MenuItem>
                                    ))}
                                </OutlinedSelect>
                            </Grid>
                            <Grid item xs={3}>
                                <OutlinedSelect
                                    id={'operator' + ruleIndex + '-' + subIndex}
                                    label="Operator"
                                    name={'operator'}
                                    margin="dense"
                                    value={condition.operator}
                                    onChange={(e) => this.handleConditionChange(e, ruleIndex, subIndex)}
                                >
                                    {operatorsList.map((operator) => (
                                        <MenuItem key={operator.value} value={operator.value}>
                                            {operator.label}
                                        </MenuItem>
                                    ))}
                                </OutlinedSelect>
                            </Grid>
                            <Grid item xs={3}>
                                {isBooleanEntry || condition.operator === 'hasValue' ? (
                                    <OutlinedSelect
                                        id={'value' + ruleIndex + '-' + subIndex}
                                        label="Value"
                                        name={'value'}
                                        margin="dense"
                                        value={condition.value}
                                        onChange={(e) => this.handleConditionChange(e, ruleIndex, subIndex)}
                                    >
                                        {valuesForBoolean.map((element) => (
                                            <MenuItem key={element.value} value={element.value}>
                                                {element.label}
                                            </MenuItem>
                                        ))}
                                    </OutlinedSelect>
                                ) : (
                                    <TextField
                                        id={'value' + ruleIndex + '-' + subIndex}
                                        margin="dense"
                                        label={
                                            condition.operator === 'in' || condition.operator === 'notIn'
                                                ? 'Value List'
                                                : 'Value'
                                        }
                                        variant="outlined"
                                        name={'value'}
                                        value={
                                            Array.isArray(condition.value) === true
                                                ? condition.value.toString()
                                                : condition.value
                                        }
                                        onChange={(e) => this.handleConditionChange(e, ruleIndex, subIndex)}
                                    ></TextField>
                                )}
                            </Grid>
                            <Grid item xs={1}>
                                {subIndex < conditions.length - 1 ? (
                                    <Typography>{booleanOperator === 'any' ? 'or' : 'and'}</Typography>
                                ) : null}
                            </Grid>
                            <Grid item xs={2} className={this.props.classes.alignEnd}>
                                <IconButton
                                    size="small"
                                    aria-label="add"
                                    onClick={() => this.addRow(ruleIndex, subIndex)}
                                >
                                    <AddCircleOutlineIcon />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    aria-label="remove"
                                    onClick={() => this.deleteRow(ruleIndex, subIndex)}
                                >
                                    <RemoveCircleOutlineIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    );
                })}
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(ConditionTable);
